import {useAgentInfo} from './use-agent-info'
import {useLatestAgentModel} from './use-latest-agent-model'
import {getAgentModelVendor} from '../utils/agent-helpers'
import type {SelectedAgent} from '../types/session'

/**
 * Resolves the model vendor and persisted model selection for a given agent.
 *
 * This hook encapsulates the common pattern of:
 * 1. Reading the vendor directly from the SelectedAgent (set when the user picks an agent from the list)
 * 2. Falling back to the server-provided `model_vendor` from AgentInfo (for enrichment/legacy paths)
 * 3. Managing the persisted per-vendor model selection in localStorage
 */
export function useAgentVendorModel(selectedAgent: SelectedAgent) {
  const {data: agentInfo} = useAgentInfo(selectedAgent.topLevelAgentId ? Number(selectedAgent.topLevelAgentId) : null)
  const agentSlug = agentInfo?.slug ?? selectedAgent.login

  // Prefer vendor from SelectedAgent (set at selection time from the list endpoint),
  // fall back to server-provided model_vendor from the individual agent info endpoint.
  const vendorFilter = getAgentModelVendor(selectedAgent.modelVendor ?? agentInfo?.model_vendor)
  const [selectedModelId, setSelectedModelId] = useLatestAgentModel(vendorFilter)

  return {agentSlug, vendorFilter, selectedModelId, setSelectedModelId}
}
